'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ui = require('./ui');

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * global
 */

exports['default'] = {
    create: function create(_ref) {
        var app = _ref.app;

        return {
            ui: _ui2['default']
        };
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/actions/index.js
 ** module id = 418
 ** module chunks = 0
 **/